import { render, staticRenderFns } from "./AttachmentUploadTableItem.vue?vue&type=template&id=3da9bdc6&scoped=true"
import script from "./AttachmentUploadTableItem.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploadTableItem.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentUploadTableItem.vue?vue&type=style&index=0&id=3da9bdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9bdc6",
  null
  
)

export default component.exports